import React from 'react'
import { Table, Button, Form, Modal, Input, Divider, InputNumber, Select } from 'antd'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import moment from 'moment'
import { Link, useHistory } from 'react-router-dom'

import styled from 'styled-components'

import PropTypes from 'prop-types'
import UserForm from './UserForm'

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledInput = styled(Input)`
  width: 256px;
`

const Users = ({
  users,
  addUserHandler,
  editUserHandler,
  addMonthsHandler,
  pagination,
  refetch,
  searchedUser
}) => {
  const [form] = Form.useForm()
  const [formForEdit] = Form.useForm()
  const [modalVisible, setModalVisible] = React.useState(false)
  const [userItem, setUserItem] = React.useState(null)
  const [editModal, setEditModal] = React.useState(false)
  const [bonusMonths, setBonusMonths] = React.useState(1)
  const [bonusPlan, setBonusPlan] = React.useState('premium')
  const [searchUsername, setSearchUsername] = React.useState(searchedUser)

  const [listUsers, setListUsers] = React.useState(null)

  React.useEffect(() => {
    const descriptiveUsers = users.map(user => {
      const expiresDate =
        user.subscription.expiresAt === 0
          ? moment()
          : moment(user.subscription.expiresAt)

      const formattedExpiresDate = expiresDate.format('DD.MM.YYYY')

      // Формируем строку с номером телефона/username и email
      let phoneEmailDisplay = ''
      if (user.phoneNumber) {
        phoneEmailDisplay = user.phoneNumber
      } else if (user.username) {
        phoneEmailDisplay = user.username
      }

      // Формируем строку с возрастом и датой рождения для отображения
      let ageDisplay = ''
      if (user.childAge) {
        ageDisplay = `${user.childAge} лет`
      }
      if (user.birthday) {
        ageDisplay += ageDisplay ? ` / ${user.birthday}` : user.birthday
      }

      return {
        id: user.id,
        phoneNumber: phoneEmailDisplay,
        name: user.name,
        childAge: ageDisplay,
        childAgeNumber: user.childAge, // Сохраняем числовое значение для формы
        birthday: user.birthday, // Сохраняем дату рождения для формы
        role: user.role,
        plan: user.subscription.plan,
        expiresDate: formattedExpiresDate,
        expiresAtTimestamp: user.subscription.expiresAt, // Сохраняем timestamp для формы
        emailAddress: user.emailAddress,
        oauthProviders: user.oauthProviders || []
      }
    })
    let searchArray = descriptiveUsers

    setTimeout(() => {
      refetch({
        search: searchUsername
      })
    }, 500)

    setListUsers(searchArray)
  }, [users, searchUsername])

  const columns = [
    {
      title: 'Имя',
      dataIndex: 'name',
      width: '25%'
    },
    {
      title: 'Номер телефона / Username / Email',
      dataIndex: 'phoneNumber',
      width: '25%'
    },
    {
      title: 'e-mail',
      dataIndex: 'emailAddress',
      width: '15%'
    },
    {
      title: 'OAuth провайдеры',
      dataIndex: 'oauthProviders',
      width: '15%',
      render: oauthProviders => {
        if (!oauthProviders || oauthProviders.length === 0) return '-'
        return oauthProviders
          .map(provider => `${provider.type} (${provider.email})`)
          .join(', ')
      }
    },
    {
      title: 'Возраст / Дата рождения',
      dataIndex: 'childAge',
      width: '20%'
    },
    {
      title: 'Роль',
      dataIndex: 'role',
      width: '15%'
    },
    {
      title: 'План',
      dataIndex: 'plan',
      width: '15%'
    },
    {
      title: 'Заканчивается',
      dataIndex: 'expiresDate',
      width: '15%'
    },
    {
      title: 'Действие',
      width: '20%',
      render: (text, item) => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {/* <span>
          <Link to={`/users/${item.id}`}>Редактировать</Link>
        </span> */}
          <Button
            type="link"
            onClick={() => {
              formForEdit.resetFields()
              setBonusMonths(1)
              setBonusPlan('premium')
              setEditModal(true)
              setUserItem(item)
            }}
          >
            Редактировать пользователя
          </Button>
          <Link to={'/userLevel/' + item.id}>Редактировать уровень</Link>
        </div>
      )
    }
  ]

  return (
    <>
      <Table
        dataSource={listUsers}
        columns={columns}
        rowKey={item => item.id}
        pagination={pagination} // Use pagination prop
        title={() => (
          <StyledHeaderContainer>
            <StyledInput
              prefix={<SearchOutlined />}
              placeholder="Поиск по имени, номеру, email, username..."
              value={searchUsername} // Set the value prop
              onChange={e => {
                setSearchUsername(e.target.value.toLowerCase())
              }}
            />

            <Button type="primary" onClick={() => setModalVisible(true)}>
              <PlusOutlined /> Новый пользователь
            </Button>
          </StyledHeaderContainer>
        )}
      />
      <Modal
        open={modalVisible}
        title="Новый пользователь"
        okText="Создать"
        cancelText="Отмена"
        onCancel={() => {
          form.resetFields()
          setModalVisible(false)
        }}
        onOk={() => addUserHandler(form, setModalVisible)}
      >
        <UserForm form={form} withPassword />
      </Modal>
      {editModal && (
        <Modal
          open={editModal}
          onCancel={() => {
            setEditModal(false)
          }}
          onOk={() => editUserHandler(formForEdit, userItem.id, setEditModal)}
        >
          <UserForm
            form={formForEdit}
            phoneNumber={userItem.phoneNumber}
            role={userItem.role}
            name={userItem.name}
            plan={userItem.plan}
            expiresDate={
              userItem.expiresAtTimestamp
                ? moment(userItem.expiresAtTimestamp)
                : moment(userItem.expiresDate, 'DD.MM.YYYY')
            }
            childAge={userItem.childAgeNumber}
            birthday={userItem.birthday}
          />
          <Divider>Добавить месяцы подписки</Divider>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <InputNumber
              min={1}
              max={36}
              value={bonusMonths}
              onChange={value => setBonusMonths(value)}
            />
            <Select
              value={bonusPlan}
              style={{ width: 140 }}
              onChange={value => setBonusPlan(value)}
            >
              <Select.Option key="basic" value="basic">
                basic
              </Select.Option>
              <Select.Option key="premium" value="premium">
                premium
              </Select.Option>
              <Select.Option key="exclusive" value="exclusive">
                exclusive
              </Select.Option>
            </Select>
            <Button
              type="primary"
              disabled={!bonusMonths || bonusMonths < 1}
              onClick={() => {
                addMonthsHandler(userItem.id, bonusMonths, bonusPlan)
                setEditModal(false)
              }}
            >
              Добавить
            </Button>
          </div>
        </Modal>
      )}
    </>
  )
}

Users.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  addUserHandler: PropTypes.func.isRequired,
  editUserHandler: PropTypes.func.isRequired,
  addMonthsHandler: PropTypes.func.isRequired
}

export default Users
